var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisGenererPlacard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3,0.5l6.9,6.9v13.8c0,1.3-1,2.3-2.3,2.3H5.1c-1.3,0-2.3-1-2.3-2.3V2.8c0-1.3,1-2.3,2.3-2.3H14.3 M18.9,21.2V8.6h-5.8 V2.8h-8v18.4H18.9 M10.8,12.4c-0.3-0.9-0.9-3.7,0.7-3.8s0.6,3.6,0.6,3.6c0.4,1.2,1.3,2.3,2.3,3c0.6-0.2,3.8-0.6,3.4,1.1 s-4,0.1-4,0.1c-1.3,0.1-2.6,0.3-3.9,0.8c-1.3,2.4-2.8,3.4-3.5,2.4c-0.8-1.3,2.5-2.9,2.5-2.9C9.7,15.4,10.4,13.9,10.8,12.4  M11.5,13.4c-0.4,1.1-0.8,2.1-1.4,3.1c1-0.3,2.1-0.6,3.1-0.8C12.5,15,11.9,14.2,11.5,13.4 M15.1,15.9c0,0,2,0.7,2.1,0.5 S15.6,15.7,15.1,15.9 M8.6,17.5c-0.9,0.4-1.7,1.8-1.5,1.8C7.8,18.9,8.3,18.3,8.6,17.5 M11.5,11.2c0-0.1,0.5-1.9,0-2 C11.2,9.1,11.5,11.1,11.5,11.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisGenererPlacard);
export default __webpack_public_path__ + "static/media/action_gris_generer-placard.cdad97f8.svg";
export { ForwardRef as ReactComponent };